import { render, staticRenderFns } from "./RemindAP.vue?vue&type=template&id=46df5746"
import script from "./RemindAP.vue?vue&type=script&lang=js"
export * from "./RemindAP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports